export const SCREENS = {
  FIRST_SCREEN: 1,
  CUSTOMER_INFO: 1,
  PREFERRED_COMMUNICATION_CHANNEL_SCREEN: 2,
  INFO: 3,
  SCHEDULED_SERVICES: 4,
  CRITICAL_ITEMS: 5,
  ADVISED_ITEMS: 6,
  OTHER_ITEMS: 7,
  SIGNATURE: 8,
  THANK_YOU: 9,
};
